export const APP_NAME = 'Bhawsar Chemicals'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'